import { create } from "zustand";

import { HEIGHT as HEADER_HEIGHT } from "app/components/Header";

const RESHOW_DELAY_MS = 14_000;

export type NewOrderBannerStore = {
  canShowBanner: boolean;
  pendingOrderId: string | null;
  bannerTop: `${string}px`;
  userClosedAt: number | null;
};

type NewOrderBannerStoreWithMethods = NewOrderBannerStore & {
  setNewOrderPending(orderId: string): void;
  setUserClosedBanner(): void;
  setBannerTop(top: `${string}px`): void;
  reset(): void;
};

const initialState: NewOrderBannerStore = {
  canShowBanner: false,
  pendingOrderId: null,
  bannerTop: HEADER_HEIGHT,
  userClosedAt: null,
};

export const useNewOrderBannerStore = create<NewOrderBannerStoreWithMethods>()((set, get) => ({
  ...initialState,
  setNewOrderPending(orderId) {
    const { userClosedAt, pendingOrderId } = get();
    const isMuted =
      userClosedAt !== null &&
      Date.now() - userClosedAt < RESHOW_DELAY_MS &&
      pendingOrderId === orderId;
    if (!isMuted) {
      set({
        canShowBanner: true,
        pendingOrderId: orderId,
      });
    }
  },
  setUserClosedBanner() {
    set({ canShowBanner: false, userClosedAt: Date.now() });
  },
  setBannerTop(top) {
    set({ bannerTop: top });
  },
  reset() {
    set(initialState);
  },
}));
